export default __webpack_public_path__ + "static/media/close-icon.dbe53574.svg";